import { render, staticRenderFns } from "./ContentLendersComparisonTable.vue?vue&type=template&id=61444920&"
import script from "./ContentLendersComparisonTable.vue?vue&type=script&lang=js&"
export * from "./ContentLendersComparisonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports